module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_sp_banner03-9ae30585b90e2b57d30649951a0c1ad0.jpg";